'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCalendar = function IoCalendar(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.8 10c-1.5 0-2.5-1.1-2.5-2.5v-2.5c0-1.4 1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v2.5c0 1.4-1.1 2.5-2.5 2.5z m17.5 0c-1.5 0-2.5-1.1-2.5-2.5v-2.5c0-1.4 1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v2.5c0 1.4-1.1 2.5-2.5 2.5z m8.1-5c0.3 0 0.6 0.3 0.6 0.6v31.3c0 0.3-0.3 0.6-0.6 0.6h-33.8c-0.3 0-0.6-0.3-0.6-0.6v-31.3c0-0.3 0.3-0.6 0.6-0.6h4.4v3.2c0 1.7 1.9 3.1 3.8 3.1s3.7-1.4 3.7-3.1v-3.2h10v3.2c0 1.7 2 3.1 3.8 3.1s3.7-1.4 3.7-3.1v-3.2h4.4z m-3.1 28.8v-20h-27.5v20h27.5z' })
        )
    );
};

exports.default = IoCalendar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/calendar.js
// module id = 2208
// module chunks = 0